module.exports = __webpack_public_path__ + "img/menu-grey.938406f5.svg";